import { go, currentRoute } from '@/lib/navigator';
import { pathOf } from '@/lib/route';
import { useRoute } from '@/hooks/useRoute';

/**
 * Which case is open — read from the address bar (`/tickets/1234`), which is
 * what makes a case linkable and lets the browser's Back button close it.
 * Opening or closing one is a navigation, so the signature stays what the
 * views already call.
 */
export function setOpenCase(id: string | null) {
  if (id) go(pathOf({ section: 'mywork', mwTab: 'tickets', caseId: id }));
  else if (currentRoute()?.caseId) go(pathOf({ section: 'mywork', mwTab: 'tickets' }));
}

export function useOpenCase(): string | null {
  return useRoute()?.caseId ?? null;
}
